import { useRecordShellEnabled } from '../../../components/RecordShell/recordShellFlag';
import { useView } from '../../../lib/access/useView';
import { usePursuitRecord } from './PursuitRecordContext';
/**
 * GRW-30 (G-11): the one edit-capability gate for pursuit panels. Inside the
 * record shell (growth_record_shell_v1 on) it is `GetPursuitHeader.capabilities`
 * (GRW-12; `canEdit` is false on a merged stub). Outside it (flag off, or a
 * panel rendered by the legacy CaptureDetailPage) it falls back to today's
 * `useView` capture_project checks, as OutputsWorkspace did. The server stays
 * authoritative either way.
 */ export function usePursuitCapabilities(fallback) {
    const shell = useRecordShellEnabled();
    const record = usePursuitRecord();
    const inRecord = shell && !!record.captureProjectId && !!record.header;
    const ref = {
        kind: 'capture_project',
        id: fallback.captureProjectId,
        objectType: 'delivery.programs',
        objectId: fallback.zouProjectId ?? ''
    };
    const enabled = !inRecord && !!fallback.captureProjectId;
    const update = useView(ref, {
        action: 'update',
        enabled
    });
    const sensitive = useView(ref, {
        action: 'view_sensitive',
        enabled
    });
    const goNoGo = useView(ref, {
        action: 'record_go_no_go',
        enabled
    });
    const convert = useView(ref, {
        action: 'convert_to_proposal',
        enabled
    });
    if (inRecord) {
        const c = record.capabilities;
        return {
            canEdit: c.canEdit,
            canViewSensitive: c.canViewSensitive,
            canRecordGoNoGo: c.canRecordGoNoGo,
            canConvertToProposal: c.canConvertToProposal,
            canCreatePursuit: c.canCreatePursuit
        };
    }
    return {
        canEdit: update.can('update'),
        canViewSensitive: sensitive.can('view_sensitive'),
        canRecordGoNoGo: goNoGo.can('record_go_no_go'),
        canConvertToProposal: convert.can('convert_to_proposal'),
        canCreatePursuit: false
    };
}
